module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAcCAMAAACwLaQWAAAAS1BMVEUAAAAzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzNOfcgEAAAAGHRSTlMAT4UK1jH2J9KjNsxnX1jr6tXGr0lAGhNfdeiaAAAAZUlEQVQY063QOQ6AMAxEUUNWQsK+zP1PitLFtkQDU74iXzGxuUAC4E8GHYAowV4CvBEA10CokNrKDCxJPnpLMN8qhwci+2ABsBHbBGA1jPra1jSSouGFmvMZVbQ/FndVzMSXC9EDH4sJMH+tvbsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/btn-back-black.png
// module id = MAYh
// module chunks = 2